(function () {
  'use strict';

  if (customElements.get('about-story-sections')) return;

  class AboutStorySections extends HTMLElement {
    connectedCallback() {
      this.disclosures = Array.from(this.querySelectorAll('[data-about-disclosure]'));
      this.mobileQuery = window.matchMedia('(max-width: 700px)');
      this.lastMobileState = null;
      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);

      this.handleBreakpointChange();

      if (this.mobileQuery.addEventListener) {
        this.mobileQuery.addEventListener('change', this.handleBreakpointChange);
      } else {
        this.mobileQuery.addListener(this.handleBreakpointChange);
      }
    }

    disconnectedCallback() {
      if (!this.mobileQuery) return;

      if (this.mobileQuery.removeEventListener) {
        this.mobileQuery.removeEventListener('change', this.handleBreakpointChange);
      } else {
        this.mobileQuery.removeListener(this.handleBreakpointChange);
      }
    }

    handleBreakpointChange() {
      const isMobile = this.mobileQuery.matches;
      if (isMobile === this.lastMobileState) return;

      this.lastMobileState = isMobile;
      this.disclosures.forEach((disclosure) => {
        disclosure.open = !isMobile;
        const summary = disclosure.querySelector('summary');
        if (summary) summary.tabIndex = isMobile ? 0 : -1;
      });
    }
  }

  customElements.define('about-story-sections', AboutStorySections);
})();
